module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "selector"
  }, [_c('span', {
    staticClass: "icon-checkmark-circle",
    class: {
      active: _vm.institutionNumberConfirmed
    }
  }), _vm._v("\n    Institutionsnummer\n  ")]), _vm._v(" "), _c('div', [_vm._v("\n    Bekræft dit institutionsnummer\n    850999\n    "), _c('button', {
    on: {
      "click": _vm.institutionNumberConfirmedClick
    }
  }, [_vm._v("Ja det er korrekt")])]), _vm._v(" "), _c('div', {
    staticClass: "selector"
  }, [_c('span', {
    staticClass: "icon-checkmark-circle",
    class: {
      active: _vm.dataAgreementConfirmed
    }
  }), _vm._v("\n    Dataaftale godkendt\n  ")]), _vm._v(" "), _c('div', [_vm._v("\n    Din skole har godkendt dataaftalen.\n    Din skole har ikke godkendt dataaftalen.\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "selector"
  }, [_c('span', {
    staticClass: "icon-checkmark-circle",
    class: {
      active: _vm.locationsConfirmed
    }
  }), _vm._v("\n    Lokaler oprettet i Aula\n  ")]), _vm._v(" "), _c('div', [_vm._v("\n    Lokaler er oprettet i Aula\n    "), _c('button', {
    on: {
      "click": _vm.locationsConfirmedClick
    }
  }, [_vm._v("Ja det er korrekt")])]), _vm._v(" "), _c('div', {
    staticClass: "selector"
  }, [_c('span', {
    staticClass: "icon-checkmark-circle",
    class: {
      active: _vm.usersImported
    }
  }), _vm._v("\n    Brugere importeret\n  ")]), _vm._v(" "), _c('div', [_vm._v("\n    35 ud af 45 brugere er importeret.\n    "), _c('button', {
    on: {
      "click": _vm.usersImportedClick
    }
  }, [_vm._v("Vis brugere der kan importeres")])]), _vm._v(" "), _c('div', {
    staticClass: "selector"
  }, [_c('span', {
    staticClass: "icon-checkmark-circle",
    class: {
      active: _vm.groupsImported
    }
  }), _vm._v("\n    Grupper importeret\n  ")]), _vm._v(" "), _c('div', [_vm._v("\n    15 ud af 18 grupper er importeret.\n    "), _c('button', {
    on: {
      "click": _vm.groupsImportedClick
    }
  }, [_vm._v("Vis grupper der kan importeres")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2a55050e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Aula/Setup.vue
// module id = 1522
// module chunks = 1